import { values } from './enums'

const Frequency = {
  DAILY: 0,
  WEEKLY: 1,
  BIWEEKLY: 2,
  MONTHLY: 3,
  QUARTERLY: 4,
  YEARLY: 5
}

const VALUES = values(Frequency)

export {
  Frequency,
  VALUES
}



// WEBPACK FOOTER //
// ./src/enums/Frequency.js